import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import { page, remove } from './api-evento';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import TablePaginationActions from '../../../shared/components/Table/Actions';
import Button from '@mui/material/Button';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useSelector, useDispatch } from 'react-redux';
import { setEventos, setEvento, removeEventos } from './actions/actions';
import { dateTimeFormat } from "../../../util/DateUtil";
import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import { green } from '@mui/material/colors';
import { red } from '@mui/material/colors';
import { errorMessage } from '../../../util/ConfirmAlertUtil';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    title: {
        paddingTop: '20px;',
        margin: '20px'
    },
    novoRegistro: {
        marginBottom: '20px',
    },
    cursorLink: {
        cursor: 'pointer'
    }
});


export default function EventoTable() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const eventos = useSelector(state => state.eventos);

    useEffect(() => {
        page(0).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    dispatch(setEventos(data));
                }
            }
        })
    }, [dispatch]);

    const handleChangePage = (event, newPage) => {
        page(newPage).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    dispatch(setEventos(data));
                }
            }
        });
    };

    const handleDelete = (index) => {
        confirmAlert({
            title: 'Alerta',
            message: 'Deseja deletar este evento?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        remove(eventos.content[index].codigo).then((data) => {
                            if (data) {
                                if (data.error) {
                                    errorMessage(data.message);
                                } else {
                                    dispatch(removeEventos(index));
                                    dispatch(setEvento(null));
                                }
                            }
                        });
                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });
    };

    return (
        <div>
            <Button
                onClick={() => dispatch(setEvento({ eNovo: true }))}
                variant="contained"
                className={classes.novoRegistro}
                color="primary">
                Novo Evento
            </Button>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell>Título</TableCell>
                        <TableCell>Início</TableCell>
                        <TableCell>Fim</TableCell>
                        <TableCell>Enviar Por</TableCell>
                        <TableCell>Enviar Para</TableCell>
                        <TableCell>Aprovado</TableCell>
                        <TableCell>Enviado</TableCell>
                        <TableCell>Criado em</TableCell>
                        <TableCell>Última Atualização</TableCell>
                        <TableCell>Ações</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {eventos.content.map((evento, index) => (
                        <TableRow key={evento.codigo}>
                            <TableCell>{evento.titulo}</TableCell>
                            <TableCell>{dateTimeFormat(evento.dataHoraInicio)}</TableCell>
                            <TableCell>{dateTimeFormat(evento.dataHoraFim)}</TableCell>
                            <TableCell>{evento.enviarPor}</TableCell>
                            <TableCell>{evento.enviarPara}</TableCell>
                            <TableCell>
                                {evento.aprovado ?
                                    <CheckCircle style={{ color: green[500] }} /> :
                                    <Cancel style={{ color: red[500] }} />}
                            </TableCell>
                            <TableCell>
                                {evento.enviado ?
                                    <CheckCircle style={{ color: green[500] }} /> :
                                    <Cancel style={{ color: red[500] }} />}
                            </TableCell>
                            <TableCell>
                                {evento.createdAt ? dateTimeFormat(evento.createdAt) : ''}
                            </TableCell>
                            <TableCell>
                                {evento.lastModified ? dateTimeFormat(evento.lastModified) : ''}
                            </TableCell>
                            <TableCell>
                                <EditIcon
                                    fontSize='small'
                                    className={classes.cursorLink}
                                    onClick={() => { dispatch(setEvento(evento)) }}
                                    color="secondary"
                                    style={{ marginRight: '10px' }} />
                                <DeleteIcon
                                    fontSize='small'
                                    className={classes.cursorLink}
                                    onClick={() => { handleDelete(index) }}
                                    color="secondary"
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[]}
                rowsPerPage={eventos.size ? eventos.size : 0}
                component="div"
                count={eventos.totalElements}
                page={eventos.number}
                onPageChange={handleChangePage}
                labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : " mais de " + to))}
                ActionsComponent={TablePaginationActions}
            />
        </div>
    );
}